import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { IcustomerService } from '../icustomer.service'
import { FormControl } from '@angular/forms';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-icustomer-table',
  templateUrl: './icustomer-table.component.html',
  styleUrls: ['./icustomer-table.component.scss']
})
export class IcustomerTableComponent implements OnInit {

  nameFilter = new FormControl('');
  filterValues = {
    id: '',
    name: '',
    mobile: '',
    customer_code: '',
  };

  // loader
  data_loaded = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;

  title = null;
  dataSource: any = null;
  displayedColumns: string[] = ['customer_code', 'id', 'name', 'mobile', 'customer_type', 'booth_code', 'booth_type', 'booth_zone', 'pincode'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;


  constructor(private global: GlobalService, private http: HttpService, public icustomerService: IcustomerService) {
    // this.global.set_master_page_title = 'Icustomer';
    this.title = this.global._active_display_name;
    this.getIcustomer();
    this.icustomerService.downloadIcustomer.subscribe((taluk) => {
      console.log(taluk);
      if (taluk) {
        this.getIcustomer();
      }
    });
  }

  getIcustomer() {
    this.http.getIcustomerList().subscribe((data: ICUSTOMER[]) => {
      console.log(data);
      this.dataSource = data;
      // this.dataSource.sort = this.sort;
      // this.dataSource.data = data;
      // this.dataSource.filterPredicate = this.createFilter();
    }, (error) => {
      console.log(error);
    });
  }

  registerIcustomer() {
    this.showIcustomerRegister();
    this.icustomerService.icustomerUpdate.emit(null);
    this.icustomerService.set_icustomer_data = null;
  }

  editIcustomer(element) {
    this.showIcustomerRegister();
    this.icustomerService.icustomerUpdate.emit(element);
    this.icustomerService.set_icustomer_data = element;
  }

  hideIcustomerRegister() {
    this.icustomerService.is_icustomer_register_component = false;
  }

  showIcustomerRegister() {
    this.icustomerService.is_icustomer_register_component = true;
  }


  ngOnInit() {
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  createFilter():
    (data: any, filter: string) => boolean {
    console.log('filter')
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toString().toLowerCase().indexOf(searchTerms.name.toString().toLowerCase()) !== -1;
    }
    return filterFunction;
  }

}


export interface ICUSTOMER {
  id: number;
  name: string;
}
